if (!window.Maximize.loadedScript.includes("video.js")) {
  window.Maximize.loadedScript.push("video.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.store("xVideo", {
        ytIframeId: 0,
        vimeoIframeId: 0,
        externalListened: false,
        togglePlay(el) {
          const videoContainer = el.closest('.external-video') || el;

          let video = videoContainer.getElementsByClassName('video')[0];
          if (video) {
            if (videoContainer) {
              const videoWrapper = el.closest('.video__wrapper');
              const videoText = videoWrapper ? videoWrapper.getElementsByClassName('video__content__text')[0] : null;
              if (videoText) {
                videoText.classList.add('pointer-events-auto');
              }
              if ((video.tagName == 'IFRAME' && videoContainer.classList.contains('function-paused')) || video.paused) {
                this.play(el);
              } else {
                this.pause(el);
              }
            }
          }
        },
        play(el) {
          const videoContainer = el.closest('.external-video') || el;
          let video = videoContainer.getElementsByClassName('video')[0];
          if (video) {
            if (videoContainer) {
              const buttonPlay = videoContainer.getElementsByClassName('button-play')[0];
              if (video.tagName == 'IFRAME') {
                if (videoContainer.classList.contains('function-paused')) this.externalPostCommand(video, 'play');
                videoContainer.classList.remove('function-paused');
              } else if (video.tagName == 'VIDEO') {
                if (!videoContainer.classList.contains('function-paused')) {
                  if (buttonPlay) buttonPlay.classList.add('hidden');
                  video.play().catch((error) => {
                    if (buttonPlay) buttonPlay.classList.remove('hidden');
                  });
                }
              }
              const videoWrapper = el.closest('.video__wrapper');
              const videoText = videoWrapper ? videoWrapper.getElementsByClassName('video__content__text')[0] : null;
              if (videoText) {
                videoText.classList.add('pointer-events-auto');
              }
            }
          }
        },
        pause(el) {
          const videoContainer = el.closest('.external-video') || el;
          let video = videoContainer.getElementsByClassName('video')[0];
          if (video) {
            if (videoContainer) {
              const buttonPlay = videoContainer.getElementsByClassName('button-play')[0];
              if (video.tagName == 'IFRAME') {
                if (!videoContainer.classList.contains('paused')) {
                  videoContainer.classList.add('function-paused');
                }
                this.externalPostCommand(video, 'pause');
              } else if (video.tagName == 'VIDEO') {
                if (buttonPlay) buttonPlay.classList.remove('hidden');
                video.pause();
              }
            }
          }
        },
        mp4Listen(el) {
          let videoContainer = el.closest('.external-video') || el;
          if (!videoContainer) return;

          let video = videoContainer.getElementsByClassName('video')[0];
          let buttonPlay = videoContainer.getElementsByClassName('button-play')[0];

          if (!video || !buttonPlay) return;

          video.addEventListener('play', function () {
            buttonPlay.classList.add('hidden');
          });

          video.addEventListener('pause', function () {
            buttonPlay.classList.remove('hidden');
          });
        },
        mp4Thumbnail(el, showControls = true) {
          const videoContainer = el.closest(".external-video");
          if (videoContainer) {
            const imgThumbnail = videoContainer.getElementsByClassName("img-thumbnail")[0];
            const buttonPlay = videoContainer.getElementsByClassName("button-play")[0];
            const video = videoContainer.getElementsByClassName("video")[0];
            if (imgThumbnail) {
              imgThumbnail.classList.add("hidden");
            }

            if (video) {
              video.setAttribute('tabindex', '0');
              video.focus();
            }

            if (buttonPlay) {
              buttonPlay.classList.add("hidden");
            }

            if (video && showControls) {
              video.setAttribute("controls", "");
            }

            this.togglePlay(el);
          }
        },
        externalLoad(el, host, id, loop, title, showControls = true) {
          let src = "";
          let pointerEvent = "";
          const controls = showControls ? 1 : 0;
          if (host == "youtube") {
            src = `https://www.youtube.com/embed/${id}?mute=1&playlist=${id}&autoplay=1&playsinline=1&enablejsapi=1&modestbranding=1&rel=0&controls=${controls}&showinfo=${controls}`;
          } else {
            src = `https://player.vimeo.com/video/${id}?muted=1&autoplay=1&playsinline=1&api=1&controls=${controls}&loop=${loop ? 1 : 0}`;
          }

          if (!showControls) {
            pointerEvent = " pointer-events-none";
          }
          requestAnimationFrame(() => {
            const videoContainer = el.closest(".external-video");
            if (videoContainer) {
              videoContainer.innerHTML = `<iframe data-video-loop="${loop}" class="iframe-video absolute w-full h-full video top-1/2 -translate-y-1/2 ${pointerEvent}"
              frameborder="0" host="${host}" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen playsinline
              src="${src}" title="${title}"></iframe>`;
              const iframeVideo = videoContainer.querySelector(".iframe-video");
              
              videoContainer.setAttribute('tabindex', '0');
              if (!loop) {
                videoContainer.focus();
              }

              if (iframeVideo) {
                iframeVideo.addEventListener("load", () => {
                  setTimeout(() => {
                    this.play(videoContainer);

                    if (host == "youtube") {
                      this.ytIframeId++;
                      iframeVideo.contentWindow.postMessage(
                        JSON.stringify({
                          event: "listening",
                          id: this.ytIframeId,
                          channel: "widget"
                        }),
                        "*"
                      );
                    } else {
                      this.vimeoIframeId++;
                      iframeVideo.contentWindow.postMessage(
                        JSON.stringify({
                          method: "addEventListener",
                          value: "finish"
                        }),
                        "*"
                      );
                      iframeVideo.contentWindow.postMessage(
                        JSON.stringify({
                          method: 'addEventListener',
                          value: 'play'
                        }),
                        "*"
                      );
                      iframeVideo.contentWindow.postMessage(
                        JSON.stringify({
                          method: 'addEventListener',
                          value: 'pause'
                        }),
                        "*"
                      );
                    }
                  }, 100);
                });
              }
            }
          });

          this.externalListen();
        },
        renderVimeoFacade(el, id, options) {
          fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${id}&width=${options.width}`)
            .then((reponse) => {
              return reponse.json();
            })
            .then((response) => {
              const html = `
                <picture>
                  <img src="${response.thumbnail_url}" loading="lazy" class="w-full h-full object-cover" alt="${options.alt}" width="${response.width}" height="${response.height}"/>
                </picture>
              `;

              requestAnimationFrame(() => {
                el.innerHTML = html;
              });
            });
        },
        renderVimeoFacadeSource(el, id, options, loading) {
          fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${id}&width=${options.width}`)
            .then((response) => response.json())
            .then((response) => {

              const source2 = document.createElement('source');
              source2.srcset = `${response.thumbnail_url}`;
              source2.media = '(min-width: 768px)';
              source2.width = response.width;
              source2.height = response.height;

              const img = document.createElement('img');
              img.src = response.thumbnail_url;
              img.loading = loading;
              img.className = 'object-cover z-10 absolute top-0 left-0 h-full w-full img-thumbnail image-hover';
              img.alt = options.alt || '';
              img.width = response.width;
              img.height = response.height;

              requestAnimationFrame(() => {
                el.appendChild(source2);
                el.appendChild(img);
              });
            });
        },
        externalListen() {
          if (!this.externalListened) {
            window.addEventListener('message', (event) => {
              var iframes = document.getElementsByTagName('IFRAME');
  
              for (let i = 0, iframe, win, message; i < iframes.length; i++) {
                iframe = iframes[i];
  
                // Cross-browser way to get iframe's window object
                win = iframe.contentWindow || iframe.contentDocument.defaultView;
  
                if (win === event.source) {
                  if (event.origin == 'https://www.youtube.com') {
                    message = JSON.parse(event.data);
                    if (iframe.getAttribute('data-video-loop') === 'true') {
                      if (message.info && message.info.playerState == 0) {
                        this.externalPostCommand(iframe, 'play');
                      }  
                    }
                    if (message.info && message.info.playerState == 1) {
                      iframe.parentNode.classList.remove('paused');
                      iframe.parentNode.classList.remove('function-paused');
                    }
                    if (message.info && message.info.playerState == 2) {
                      iframe.parentNode.classList.add('paused');
                    }
                  }
  
                  if (event.origin == 'https://player.vimeo.com') {
                    message = JSON.parse(event.data);
                    if (iframe.getAttribute('data-video-loop') !== 'true') {
                      if (message.event == "finish") {
                        this.externalPostCommand(iframe, 'play');
                      }
                    }
                    if (message.event === 'play') {
                      iframe.parentNode.classList.remove('paused');
                      iframe.parentNode.classList.remove('function-paused');
                    }
                    if (message.event === 'pause') {
                      iframe.parentNode.classList.add('paused');
                    }
                  }
                }
              }
            });
  
            this.externalListened = true;
          }
        },
        externalPostCommand(iframe, cmd) {
          const host = iframe.getAttribute("host");
          const command =
            host === "youtube"
              ? {
                "event": "command",
                "func": cmd + "Video",
              }
              : {
                "method": cmd,
                "value": "true",
              };
          iframe.contentWindow.postMessage(JSON.stringify(command), "*");
        },
        toggleMute(el) {
          let video = el.closest(".video-wrapper") && el.closest(".video-wrapper").getElementsByClassName("video")[0];
          if (video) {
            if (video.tagName != "IFRAME") {
              video.muted = !video.muted;
            }
          }
        },
      });
    })
  });


  class CustomVideo extends HTMLVideoElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener("play", () => {
        this.classList.add('is-playing')
      })

      this.addEventListener("pause", () => {
        this.classList.remove('is-playing')
      })
    }
  }

  customElements.define("custom-video", CustomVideo, { extends: "video" });
}
